module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAAAXNSR0IArs4c6QAAACdQTFRFAAAAVVVVVVVVU1NTVVVVVVVVU1NTVFRUVVVVVFRUVVVVVFRUVVVVPF8ZBAAAAAx0Uk5TAAwzND9La7O3v+vv6b/VSwAAAEZJREFUCNdjYMACWNecAYFTAQxcBmAB5gUMPFC5AyisPWc2YIghy545jUuWSwHMYFoAse2kBNA2MOCshDmD5QjcRQnIzgMAovAZ4mHTkswAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/chat.png
// module id = TM71
// module chunks = 28